export default{
    results: '     <h4>Αποτελέσματα εισαγωγής</h4>\n' +
        '      <p CLASS="mt-3">Η μαζική εισαγωγή των πελατών ολοκληρώθηκε επιτυχώς. </p>\n' +
        '      <P>Τα αποτελέσματα της εισαγωγής ήταν τα ακόλουθα:</P>\n' +
        '      <ul>\n' +
        '        <li>Συνολικοί πελάτες: {total}</li>\n' +
        '        <li>Πελάτες που προστέθηκαν: {imported}</li>\n' +
        '        <li>Πελάτες που υπήρχαν ήδη: {duplicates}</li>\n' +
        '      </ul>',
    guide: {
        intro: 'Εισήγαγε μαζικά τους πελάτες σου ανεβάζοντας ένα αρχείο CSV (π.χ. από το Excel), με τις παρακάτω στήλες.',
        required: 'Υποχρεωτικό',
        columns: {
            firstName: 'Το μικρό όνομα του πελάτη',
            lastName: 'Το επώνυμο του πελάτη',
            email: 'Με αυτό αναγνωρίζουμε πελάτες που έχεις ήδη',
            birthDate: 'Ως ΗΗ/ΜΜ/ΕΕΕΕ, π.χ. 25/03/1990',
            sex: 'Α για άνδρα, Γ για γυναίκα',
            mobileNum: 'Π.χ. 6912345678',
            sessionCost: 'Ποσό σε €, π.χ. 40 ή 40,50',
        },
        notes: {
            headers: 'Οι επικεφαλίδες μπορούν να είναι στα ελληνικά ή στα αγγλικά, με οποιαδήποτε σειρά. Άφησε κενά τα πεδία που δεν έχεις.',
            allOrNothing: 'Αν κάποια γραμμή έχει λάθος, δεν προστίθεται κανένας πελάτης και θα δεις ποιες γραμμές χρειάζονται διόρθωση.',
            duplicates: 'Πελάτες που έχεις ήδη παραλείπονται: με ίδιο email ή, αν η γραμμή δεν έχει email, με ίδιο ονοματεπώνυμο.',
        },
        template: 'Κατέβασε το πρότυπο αρχείο',
        safari: 'Αν η λήψη δεν ξεκινά στο Safari, δοκίμασε Google Chrome.',
    },
    errors: {
        title: 'Δεν προστέθηκε κανένας πελάτης',
        invalid: 'Βρήκαμε {count} πρόβλημα στο αρχείο. Διόρθωσέ το και ανέβασέ το ξανά. | Βρήκαμε {count} προβλήματα στο αρχείο. Διόρθωσέ τα και ανέβασέ το ξανά.',
        row: 'Γραμμή {row}',
        more: '…και {count} ακόμα',
        retry: 'Ανέβασμα διορθωμένου αρχείου',
        fields: {
            firstName: 'Όνομα',
            lastName: 'Επώνυμο',
            email: 'Email',
            birthDate: 'Ημερομηνία γέννησης',
            sex: 'Φύλο',
            mobileNum: 'Κινητό',
            sessionCost: 'Κόστος συνεδρίας',
        },
        codes: {
            REQUIRED: 'είναι υποχρεωτικό',
            INVALID_EMAIL: 'δεν είναι έγκυρο email',
            INVALID_DATE: 'δεν είναι έγκυρη ημερομηνία, γράψε τη ως ΗΗ/ΜΜ/ΕΕΕΕ',
            DATE_OUT_OF_RANGE: 'πρέπει να είναι μεταξύ 1900 και σήμερα',
            INVALID_GENDER: 'γράψε Α για άνδρα ή Γ για γυναίκα',
            PHONE_SCIENTIFIC_NOTATION: 'το Excel το μετέτρεψε σε μορφή «6,91E+09». Όρισε τη στήλη ως κείμενο και πληκτρολόγησε ξανά τον αριθμό',
            INVALID_COST: 'δεν είναι έγκυρο ποσό',
        },
        file: {
            CSV_IMPORT_EMPTY: 'Το αρχείο δεν περιέχει πελάτες.',
            CSV_IMPORT_TOO_MANY_ROWS: 'Το αρχείο έχει {total} πελάτες. Μπορείς να εισαγάγεις έως {maxRows} τη φορά, χώρισέ το σε μικρότερα αρχεία.',
            CSV_IMPORT_NO_FILE: 'Ανέβασε ένα αρχείο .csv.',
            quota_exceeded: 'Έχεις ήδη {current} από τους {limit} πελάτες που επιτρέπει ο λογαριασμός σου, οπότε οι πελάτες του αρχείου δεν χωράνε.',
            tooBig: 'Το αρχείο είναι πολύ μεγάλο. Το όριο είναι 1MB.',
            generic: 'Κάτι πήγε στραβά με το αρχείο. Δοκίμασε ξανά.',
        },
    },
}
